import {
  useController,
  type FieldValues,
  type Path,
  type PathValue,
  type UseControllerProps,
  type UseControllerReturn,
} from 'react-hook-form';
import { Select } from './Select.tsx';

type Props<T extends FieldValues, N extends Path<T>> = {
  renderOptions: ({
    onChange,
  }: {
    onChange: UseControllerReturn['field']['onChange'];
  }) => NonNullable<React.ReactElement>;
  renderValue?: (val: PathValue<T, N>) => string | null;
} & Omit<React.ComponentProps<typeof Select>, 'children' | 'renderValue' | 'value'> &
  UseControllerProps<T, N>;

export function SelectControlled<T extends FieldValues, N extends Path<T>>({
  control,
  rules,
  name,
  renderOptions,
  ...props
}: Props<T, N>) {
  const {
    field: { ref, onChange, value, onBlur },
  } = useController({
    name,
    control,
    rules,
  });

  return (
    <Select
      onBlur={onBlur}
      innerRef={ref}
      defaultValue={value ?? undefined}
      value={value}
      onChange={onChange}
      {...props}
    >
      {renderOptions({ onChange })}
    </Select>
  );
}
